import React from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useCountry } from "../contexts/CountryContext";

export default function CountrySelector() {
  const { selectedCountry, setSelectedCountry, countries } = useCountry();

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
  };

  return (
    <div>
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <MenuButton className="inline-flex items-center text-xs w-full justify-center gap-x-1.5  bg-white px-3 py-1 font-semibold text-themeSemiGray  ring-1 ring-inset ring-gray-200 hover:bg-gray-50">
            {selectedCountry.name}
            <ChevronDownIcon
              aria-hidden="true"
              className="-mr-1 h-5 w-5 text-gray-400"
            />
          </MenuButton>
        </div>

        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
          <div className="py-1">
            {countries.map((country) => (
              <MenuItem key={country.code}>
                <button
                  onClick={() => handleCountrySelect(country)}
                  className={`block px-4 text-left w-full py-2 text-sm data-[focus]:bg-gray-100 data-[focus]:text-gray-900 ${
                    selectedCountry.code === country.code
                      ? "bg-themeOrange text-white"
                      : "text-gray-700"
                  }`}
                >
                  {country.name}
                </button>
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Menu>
    </div>
  );
}
